"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var material_1 = require("@mui/material");
var react_1 = require("react");
var Order_1 = __importDefault(require("./Order/Order"));
var CircularProgress_1 = __importDefault(require("@mui/material/CircularProgress"));
var context_1 = require("../context");
var lodash_1 = __importDefault(require("lodash"));
function OrdersList(_a) {
    var orders = _a.orders, status = _a.status, isLoading = _a.isLoading;
    var _b = (0, react_1.useState)(undefined), selected = _b[0], setSelected = _b[1];
    var translations = (0, context_1.useTwapContext)().translations;
    var onSelect = function (value) {
        setSelected(function (prevState) { return (prevState === value ? undefined : value); });
    };
    if (isLoading) {
        return ((0, jsx_runtime_1.jsx)(StyledLoader, { children: (0, jsx_runtime_1.jsx)(CircularProgress_1.default, { className: "twap-spinner" }) }));
    }
    return ((0, jsx_runtime_1.jsx)(StyledContainer, __assign({ className: "twap-orders-list" }, { children: lodash_1.default.size(orders) ? (orders === null || orders === void 0 ? void 0 : orders.map(function (order, index) {
            return (0, jsx_runtime_1.jsx)(Order_1.default, { order: order, expanded: index === selected, onExpand: function () { return onSelect(index); } }, index);
        })) : ((0, jsx_runtime_1.jsx)(StyledEmptyList, __assign({ className: "twap-orders-empty-list" }, { children: !status ? "You currently don't have orders" : "".concat(translations.noOrdersFound, " ").concat(translations["noOrdersFound_" + status], " ").concat(translations.noOrdersFound1) }))) })));
}
exports.default = OrdersList;
var StyledEmptyList = (0, material_1.styled)(material_1.Box)({
    textAlign: "center",
    paddingTop: 40,
    marginBottom: 40,
});
var StyledContainer = (0, material_1.styled)(material_1.Box)({
    width: "100%",
    display: "flex",
    flexDirection: "column",
    gap: 20,
});
var StyledLoader = (0, material_1.styled)(StyledContainer)({
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    height: 110,
    "& .twap-spinner": {
        color: "white",
    },
});
